import React, { useEffect, useState } from "react";
import { db } from '../../../firebase';
import { collection, getDocs } from "firebase/firestore";
import NavBars from '../../Sidebar/Sidebar';

const Progress = () => {
  const [subUnits, setSubUnits] = useState([]); // Stores subunits
  const [selectedSubUnit, setSelectedSubUnit] = useState(null); // Selected subunit ID
  const [progress, setProgress] = useState({}); // Progress for each subunit
  const [tasks, setTasks] = useState([]); // Tasks of selected subunit

  useEffect(() => {
    const fetchSubUnits = async () => {
      try {
        const subUnitSnapshot = await getDocs(collection(db, "sub-units"));
        const subUnitData = subUnitSnapshot.docs.map((docSnapshot) => {
          const subUnit = docSnapshot.data();
          return {
            id: docSnapshot.id,
            name: subUnit.name,
            tasks: Array.isArray(subUnit.tasks) ? subUnit.tasks : [] // Ensure tasks is an array
          };
        });

        setSubUnits(subUnitData);

        // Compute progress for each subunit
        const subUnitProgress = {};
        subUnitData.forEach(subUnit => {
          subUnitProgress[subUnit.id] = calculateProgress(subUnit.tasks);
        });

        setProgress(subUnitProgress);
      } catch (error) {
        console.error("Error fetching sub-units:", error);
      }
    };

    fetchSubUnits();
  }, []);

  const handleSubUnitChange = (e) => {
    const subUnitId = e.target.value;
    setSelectedSubUnit(subUnitId);

    const selected = subUnits.find(subUnit => subUnit.id === subUnitId);
    if (selected) {
      setTasks(selected.tasks);
      setProgress((prevProgress) => ({
        ...prevProgress,
        [subUnitId]: calculateProgress(selected.tasks)
      }));
    }
  };

  const calculateProgress = (tasksArray) => {
    if (!Array.isArray(tasksArray) || tasksArray.length === 0) return 0;

    let totalDuration = 0;
    let elapsedDuration = 0;
    const currentDate = new Date();

    tasksArray.forEach((task) => {
      const startDate = new Date(task.startDate);
      const endDate = new Date(task.endDate);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return;

      totalDuration += endDate - startDate;

      if (task.status === "completed") {
        elapsedDuration += endDate - startDate;
      } 
    });

    return totalDuration > 0 ? ((elapsedDuration / totalDuration) * 100).toFixed(2) : 0;
  };

  // Get selected subunit data
  const selectedSubUnitData = subUnits.find(subUnit => subUnit.id === selectedSubUnit) || {};

  // Separate completed and remaining tasks
  const completedTasks = tasks.filter(task => task.status === "completed");
  const remainingTasks = tasks.filter(task => task.status !== "completed");

  return (
    <div>
      <div className="content">
        <h2>Subunit Progress</h2>

        {/* Subunit selection dropdown */}
        <select onChange={handleSubUnitChange} value={selectedSubUnit || ''}>
          <option value="" disabled>Select Subunit</option>
          {subUnits.map((subUnit) => (
            <option key={subUnit.id} value={subUnit.id}>
              {subUnit.name}
            </option>
          ))}
        </select>

        {/* Progress bar */}
        {selectedSubUnit && (
          <div className="progress-bar-container">
            <h3>Progress for {selectedSubUnitData?.name}</h3>
            <progress value={progress[selectedSubUnit] || 0} max="100" />
            <span>{progress[selectedSubUnit] || 0}% Complete</span>
          </div>
        )}

        {/* Task lists */}
        {selectedSubUnit && (
          <div className="task-list">
            <h3>Completed Tasks</h3>
            <ul>
              {completedTasks.map(task => (
                <li key={task.id} style={{ color: "green" }}>
                  <strong>{task.name}</strong> - Status: {task.status} (Start: {task.startDate}, End: {task.endDate})
                </li>
              ))}
            </ul>

            <h3>Remaining Tasks</h3>
            <ul>
              {remainingTasks.map(task => (
                <li key={task.id} style={{ color: "red" }}>
                  <strong>{task.name}</strong> - Status: {task.status} (Start: {task.startDate}, End: {task.endDate})
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <NavBars />
    </div>
  );
};

export default Progress;
